import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "@tanstack/react-router";

import { analytics } from "@/config/analytics";
import { queryClient } from "@/config/query-client";
import { router } from "@/config/router";
import { initializeSentry } from "@/config/sentry";
import { initializeTheme } from "@/config/theme";
import { env } from "@/env";
import { useMaintenanceMode } from "@/hooks/use-maintenance-mode";

import "./index.css";

analytics.init();
initializeSentry();
initializeTheme();

const App = () => {
  useMaintenanceMode();

  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />

        {env.VITE_APP_ENV === "local" && (
          <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
        )}
      </QueryClientProvider>
    </StrictMode>
  );
};

createRoot(document.getElementById("root")!).render(<App />);
